import { useEffect } from 'react';
import { getProductBrandRandomDisplay } from '~kup/controllers/productBrand.ts';
import { getProductCollectionByBrand } from '~kup/controllers/productCollection.ts';
import { ProductBrand } from '~kup/models/ProductBrand.ts';
import { ProductCollection } from '~kup/models/ProductCollection.ts';
import useLoading from '~/hooks/useLoading.tsx';
import { useKeepState } from '~/hooks/useKeepState.ts';

type UseBrandPick = {
  loading: boolean;
  pickedBrand: ProductBrand | null;
  pickedBrandCollection: ProductCollection | null;
  setPickedBrand: (brand: ProductBrand) => void;
};

export default function useBrandPick(keepStateKey?: string): UseBrandPick {
  const { loading, startLoading, stopLoading } = useLoading();
  const [pickedBrand, setPickedBrand] = useKeepState<ProductBrand | null>(
    (keepStateKey ?? 'pickedBrand') + ':brand',
    null
  );
  const [pickedBrandCollection, setPickedBrandCollection] = useKeepState<ProductCollection | null>(
    (keepStateKey ?? 'pickedBrand') + ':brandCollection',
    null
  );

  useEffect(() => {
    startLoading();
    getProductBrandRandomDisplay()
      .then((brand) => {
        setPickedBrand(brand);
        if (brand) return getProductCollectionByBrand(brand.id, 'random');
        else return [];
      })
      .then((collections) => {
        setPickedBrandCollection(collections[0]);
      })
      .finally(stopLoading);
  }, []);

  return { loading, pickedBrand, pickedBrandCollection, setPickedBrand };
}
